import React from "react";
import "./MobileBottomNav.css";

const ICONS = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11.5 12 4l9 7.5" />
      <path d="M5 10v9a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9" />
    </svg>
  ),
  projects: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7a1 1 0 0 1 1-1h4l2 2h10a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7Z" />
    </svg>
  ),
  time: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9v4l3 2" />
      <path d="M9 2h6" />
    </svg>
  ),
  more: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
};

/**
 * Persistent mobile bottom tab bar (<1024px only — desktop keeps the
 * sidebar). Reuses existing screen-navigation handlers only.
 *
 * The bar renders 4 real tabs occupying its left 80% (Home / Projects /
 * Time / More) and reserves the right 20% as an empty slot — the existing
 * Ashley FAB (FloatingHomeButton) is a separate, independently-mounted
 * component (unchanged: same gesture/quick-menu logic, and still visible
 * on desktop, where this bar doesn't render at all) that CSS repositions
 * to sit exactly in that reserved slot at mobile widths, so it visually
 * reads as this bar's 5th item instead of floating over it. See
 * FloatingHomeButton.css's `@media (max-width: 1023px)` block.
 */
export function MobileBottomNav({
  hidden,
  activeTab,
  onOpenDashboard,
  onOpenProjects,
  onOpenTime,
  onOpenMore,
}) {
  if (hidden) {
    return null;
  }

  const tabs = [
    { id: "home", label: "Home", icon: ICONS.home, onClick: onOpenDashboard },
    { id: "projects", label: "Projects", icon: ICONS.projects, onClick: onOpenProjects },
    { id: "time", label: "Time", icon: ICONS.time, onClick: onOpenTime },
    { id: "more", label: "More", icon: ICONS.more, onClick: onOpenMore },
  ];

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`mobile-bottom-nav__item${activeTab === tab.id ? " is-active" : ""}`}
          onClick={tab.onClick}
          aria-current={activeTab === tab.id ? "page" : undefined}
        >
          {tab.icon}
          <span>{tab.label}</span>
        </button>
      ))}
      {/* Reserved for Ashley — see file header comment. */}
      <div className="mobile-bottom-nav__ashley-slot" aria-hidden="true" />
    </nav>
  );
}
